import { Result } from "antd";
import { Card } from "react-bootstrap";
import { useState, useEffect } from "react";
import CustomStore from "devextreme/data/custom_store";
import DataGrid, {
    Column,
    Pager,
    Paging,
    SearchPanel,
    Summary,
    TotalItem,
} from "devextreme-react/cjs/data-grid";
import useHasPermission from "hooks/useHasPermission";
import AddSubCategoryModal from "./components/AddSubCategory";
import ActionSubCategory from "./components/ActionSubcategory";
import { GetAllSubCategory, GetCategorySelectList } from "./services/SubCategoryservises";

const SubCategoryDataList = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const hasPermission = useHasPermission();


    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    const response = await GetAllSubCategory(parameterList);

                    

                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">Sub Category</h5>
                            <AddSubCategoryModal reloadDataSource={reloadDataSource} />
                        </Card.Header>
                        <Card.Body>
                            {hasPermission("SubCategory.Read") ? (
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    columnAutoWidth={true}
                                    showBorders={true}
                                >
                                    <Paging defaultPageSize={10} />
                                    <Pager
                                        visible={true}
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />
                                    <Summary>
                                        <TotalItem />
                                    </Summary>
                                     {(hasPermission("Category.Write") ||
                                        hasPermission("Category.Delete")) && (
                                            <Column
                                                caption="Action"
                                                width="100"
                                                cellRender={({ data }) => (
                                                    <div className="d-flex justify-content-start align-items-center gap-2">
                                                        <ActionSubCategory
                                                            selectedCategoryId={data.id as string}
                                                            selectedCategoryName={data.name}
                                                            onDeleteSuccess={reloadDataSource}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}

                                    <Column
                                        dataField="categoryName"
                                        caption="Category"
                                        width={150}
                                        
                                    />

                                    <Column
                                        dataField="name"
                                        caption="SubCategory Name"
                                        dataType="string"
                                    />

                                   

                                    <Column
                                        dataField="id"
                                        dataType="number"
                                        sortOrder="desc"
                                        visible={false}
                                        allowFiltering={false}
                                    />
                                </DataGrid>
                            ) : null}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default SubCategoryDataList;
